<template>
  <div v-if="isLoading">
    <v-layout justify-center>
      <div class="white-widget grey-bg author-area">
        <div class="auth-info row">
          <div class="timeline-wrapper">
            <div class="timeline-item">
              <div class="animated-background">
                <div class="background-masker header-top"></div>
                <div class="background-masker header-left"></div>
                <div class="background-masker header-right"></div>
                <div class="background-masker header-bottom"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-layout>
  </div>

  <div v-else class>
    <!-- MOBILE -->
    <v-container :lazy="true" class="ma-0 pa-0 hidden-md-and-up" fluid>
      <v-card light id="card-variable-height" height="92vh" class>
        <v-card-media class height="45vh" :src="collection.imgUrl[0].url+'_single'">
          <div class="mainImg-overlay" style>
            <div class="wave-img"></div>
          </div>

          <v-container fill-height fluid class="pr-1 pl-1">
            <v-layout fill-height column class="media">
              <!-- <v-flex xs12 align-start>
                <v-icon class="body-1 white--text">library_books</v-icon> <span class="body-1 white--text" v-for="items in artefact.collectionId" :key="items" > {{items}}</span>
              </v-flex>-->
              <v-card-actions>
                <v-layout>
                  <v-icon dark>view_day</v-icon>
                </v-layout>

                <v-layout v-if="isAdmin">
                  <v-spacer></v-spacer>
                  <v-btn class="headerButtons" flat icon @click="addToFav">
                    <v-icon dark v-if="!favorited">favorite_border</v-icon>
                    <v-icon dark v-else>favorite</v-icon>
                  </v-btn>
                  <v-btn class="headerButtons" flat icon to="'/collections/new/' ">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-btn class="headerButtons" flat icon @click.native.stop="dialog = true">
                    <v-icon dark>delete</v-icon>
                  </v-btn>

                  <v-dialog v-model="dialog" max-width="290">
                    <v-card>
                      <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                      <v-card-text>{{gLang[lang].collectionSingle.delete}}</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          flat="flat"
                          @click.native="dialog = false"
                        >{{gLang[lang].artefactSingle.btnno}}</v-btn>
                        <v-btn
                          color="primary"
                          flat="flat"
                          @click="deleteArtefact"
                        >{{gLang[lang].artefactSingle.btnyes}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-layout>
                <v-layout v-else-if="!isAdmin && isLoggedIn">
                  <v-spacer></v-spacer>
                  <v-btn class="headerButtons" flat icon @click="addToFav">
                    <v-icon dark v-if="!favorited">favorite_border</v-icon>
                    <v-icon dark v-else>favorite</v-icon>
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-layout>
          </v-container>
        </v-card-media>

        <v-card-title class="pr-0 pl-0 mt-0">
          <v-layout class="text-xs-center d-block">
            <h3 class="headline mb-0 pb-2">{{collection.title[lang]}}</h3>
            <hr style="margin-left:20%;margin-right:20%;color:#efefef; border-style:solid;">
            <div class="pt-3 pb-0">
              <!-- <div v-for="groups in collection.groups" :key="groups">
            <span style="padding:10px" ><v-icon left >group_work</v-icon>{{groups}}</span>
              </div>-->
              <v-layout class="pl-4 pr-4" row wrap justify-center>
                <span
                  v-for="(group,i) in  collection.groups "
                  :key="i"
                  v-if="i<7 && getLanguageTranslation(group)!=false"
                >&nbsp;
                  <v-icon left>view_column</v-icon>
                  {{getLanguageTranslation(group)}}
                </span>
                <!-- <v-flex xs4><span><v-icon left dark >label</v-icon> {{artefact.collectionId[1]}}</span></v-flex> -->
              </v-layout>
            </div>
          </v-layout>
        </v-card-title>

        <v-layout justify-center>
          <v-card-actions>
            <v-btn fab href="#description" v-smooth-scroll="{ duration: 1000, offset: -50 }">
              <v-icon light>keyboard_arrow_down</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
      <web-location-tab :artefact="collection" :isCollection="true" :light="true" class="pl-0 pr-0">
        <div v-if="overview">
          <v-card color=" mt-3 mb-3" flat id="description">
            <v-layout row>
              <v-flex xs10 offset-xs1>
                <v-card class="card--flex-toolbar">
                  <v-toolbar card color="white" prominent>
                    <v-toolbar-title class="body-2 grey--text">
                      <v-icon left>info_outline</v-icon>
                      {{gLang[lang].collectionSingle.about}}
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-card-text v-if="collection.description[lang].length > 250">
                    <div v-if="isMinimized">
                      <p class="caption">{{collection.description[lang].slice(0,250)}}...</p>
                      <v-flex class="text-xs-right">
                        <v-btn
                          flat
                          primary
                          @click="isMinimized = !isMinimized"
                        >{{gLang[lang].collectionSingle.readMore}}</v-btn>
                      </v-flex>
                    </div>
                    <div v-if="!isMinimized">
                      <p class="caption">{{collection.description[lang]}}</p>
                      <v-flex class="text-xs-right">
                        <v-btn
                          flat
                          primary
                          @click="isMinimized = !isMinimized"
                        >{{gLang[lang].collectionSingle.readLess}}</v-btn>
                      </v-flex>
                    </div>
                  </v-card-text>
                  <v-card-text v-else>
                    <p class="caption">{{collection.description[lang]}}</p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card color=" mt-5 mb-3" flat v-if="artefactsInCollection()">
            <v-toolbar-title
              class="body-2 grey--text mt-4 ml-5"
            >{{gLang[lang].collectionSingle.artefacts}}</v-toolbar-title>
            <v-divider class="mb-4"></v-divider>
            <web-slider1 :artefacts="artefacts">
              <div
                v-for="artefact in artefacts"
                :key="artefact._id"
                v-if="(artefact.collectionId.indexOf(collection.title.en) > -1 && lessThen5(artefact._id,collection.title.en))"
              >
                <web-artefact-card :artefact="artefact"></web-artefact-card>
              </div>
            </web-slider1>

            <v-card-actions class="pt-1 mt-0">
              <v-flex class="text-xs-right">
                <v-btn flat @click="showAll">{{gLang[lang].collectionSingle.show}}</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>

          <!-- <v-flex xs4>
        <img class="variableWidth" id="myImg2" v-on:resize="handleSize()"  v-on:click="imageClick('https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg')" style="width:100px; height:100px" src="https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg" alt="">
      </v-flex>
      <v-flex xs4>
        <img class="variableWidth" id="myImg3" v-on:resize="handleSize()"  v-on:click="imageClick('http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23')" style="width:100px; height:100px" src="http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23" alt="">
      </v-flex>
    </v-layout>
    <v-layout row justify-center class="pl-2">
          <v-flex xs4>-->
          <!-- {{image.Url}} will be added as an argument to the imageClick function -->
          <!-- <img class="variableWidth" id="myImg4" v-on:resize="handleSize()"  v-on:click="imageClick('https://i.pinimg.com/736x/71/12/80/71128071f2b38e1a093aab2b6eacb9c5--melted-crayon-diy-crayon-melting-canvas.jpg')"  style="width:100px; height:100px" src="https://i.pinimg.com/736x/71/12/80/71128071f2b38e1a093aab2b6eacb9c5--melted-crayon-diy-crayon-melting-canvas.jpg" alt="">
      </v-flex>
      <v-flex xs4>
        <img class="variableWidth" id="myImg5" v-on:resize="handleSize()"  v-on:click="imageClick('https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg')" style="width:100px; height:100px" src="https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg" alt="">
      </v-flex>
      <v-flex xs4>
        <img class="variableWidth" id="myImg6"  v-on:resize="handleSize()" v-on:click="imageClick('http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23')" style="width:100px; height:100px" src="http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23" alt="">
          </v-flex>-->
        </div>
        <div v-else>
          <web-location-present-multiple
            style="box-shadow:0px;"
            :groupTitle="collection"
            :heightM="mapHeight1"
          ></web-location-present-multiple>
        </div>

        <!-- The Modal -->
        <div style="margin-top:56px;" id="myModal" class="modal pt-5">
          <v-btn dark medium fab color="black" v-on:click="spanClick" class="close">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <div
            v-for="artefact in artefacts"
            :key="artefact._id"
            v-if="(artefact.collectionId.indexOf(collection.title.en) > -1)"
          >
            <v-container>
              <v-layout row wrap>
                <web-artefact-card class="modal-card" :artefact="artefact"></web-artefact-card>
              </v-layout>
            </v-container>
          </div>
        </div>

        <!-- <iframe id="video" class="video"
:src="media.data[0].url">
        </iframe>-->
        <v-divider></v-divider>

        <!-- <vue-audio :file="media.data[0].url"></vue-audio> -->
        <!-- <v-layout row>
          <div class=" ml-3 mb-3 mt-2 pa-1 mr-3 icon-circle primary" style="">
        <v-icon dark >library_music</v-icon>
          </div>
          <div>
            <a class="pdfText" href=""> <b>{{media.data[0].originalName}}</b></a> <br>
            <p class="pdfDate">{{artefact.meta.creationDate | date}}</p>
        </div>   
                 
        </v-layout>-->
        <web-speed-dial-add v-if="isMod||isContrib"></web-speed-dial-add>
      </web-location-tab>
    </v-container>

    <!-- DESKTOP -->
    <v-container class="ma-0 pa-0 hidden-sm-and-down" fluid>
      <div
        class="hide-ie"
        style="position:absolute; width:100%; height:74vh; position:fixed; overflow:hidden"
      >
        <img
          :src="collection.imgUrl[0].url+'_single'"
          style="width:100%; bottom:100px; position:relative;height: 100%;height: auto"
        >
        <!-- <v-parallax :src="collection.imgUrl[0].url" height="70vh" style="width:100%; bottom:100px; position:relative"></v-parallax> -->
      </div>
      <img
        :src="collection.imgUrl[0].url+'_single'"
        class="show-ie"
        style="position:absolute; width:100%; height:70vh; position:fixed;"
      >

      <div class="mainImg-overlay1 hide-ie" style="  position:fixed;"></div>
      <v-card
        light
        style="background-color:transparent; box-shadow:none; position:relative"
        id="card-variable-height"
        height="65vh"
        class
      >
        <div class="floatingScrollButton" style=" position:absolute; width:100%;">
          <v-layout justify-center class style="height:100%; position:relative; width:100%;">
            <h3
              style="color:white; height:30px; position:absolute; top:32%; text-align:center"
              class
            >{{collection.title[lang]}}</h3>
            <v-btn
              style="top:52%; z-index:999; "
              fab
              href="#toScrollDescription"
              v-smooth-scroll="{ duration: 1000, offset: -50 }"
            >
              <v-icon light>keyboard_arrow_down</v-icon>
            </v-btn>
          </v-layout>
        </div>

        <v-layout
          class="pl-4 pr-4 pt-4"
          row
          wrap
          justify-center
          style="height:60px;    top: 62%;
    position: absolute; width:100%"
        >
          <span
            style="z-index:90; color:white"
            v-for="(group,i) in  collection.groups "
            :key="i"
            v-if="i<7 && getLanguageTranslation(group)!=false"
          >&nbsp;
            <v-icon left dark>view_column</v-icon>
            {{getLanguageTranslation(group)}}
          </span>
          <!-- <v-flex xs4><span><v-icon left dark >label</v-icon> {{artefact.collectionId[1]}}</span></v-flex> -->
        </v-layout>

        <v-card-media class height="50vh">
          <div class="wave-img1 hide-ie"></div>

          <v-container fill-height fluid class="pr-1 pl-1">
            <v-layout fill-height column class="media">
              <v-flex md10 offset-md1>
                <!-- <v-flex xs12 align-start>
                <v-icon class="body-1 white--text">library_books</v-icon> <span class="body-1 white--text" v-for="items in artefact.collectionId" :key="items" > {{items}}</span>
                </v-flex>-->
                <v-card-actions>
                  <v-layout>
                    <v-icon dark>view_day</v-icon>
                  </v-layout>

                  <v-layout v-if="isAdmin">
                    <v-spacer></v-spacer>
                    <v-btn flat class="headerButtons" icon @click="addToFav">
                      <v-icon dark v-if="!favorited">favorite_border</v-icon>
                      <v-icon dark v-else>favorite</v-icon>
                    </v-btn>
                    <v-btn flat class="headerButtons" icon :to="'/collections/new/' ">
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                    <v-btn flat class="headerButtons" icon @click.native.stop="dialog = true">
                      <v-icon dark>delete</v-icon>
                    </v-btn>

                    <v-dialog v-model="dialog" max-width="290">
                      <v-card>
                        <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                        <v-card-text>{{gLang[lang].collectionSingle.delete}}</v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            flat="flat"
                            @click.native="dialog = false"
                          >{{gLang[lang].artefactSingle.btnno}}</v-btn>
                          <v-btn
                            color="primary"
                            flat="flat"
                            @click="deleteArtefact"
                          >{{gLang[lang].artefactSingle.btnyes}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                  <v-layout v-else-if="!isAdmin && isLoggedIn">
                    <v-spacer></v-spacer>
                    <v-btn flat class="headerButtons" icon @click="addToFav">
                      <v-icon dark v-if="!favorited">favorite_border</v-icon>
                      <v-icon dark v-else>favorite</v-icon>
                    </v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-media>
      </v-card>

      <v-layout justify-center style="background-color:#FAFAFA;">
        <v-flex md10 style="position:relative;" id="toScrollDescription" class="shadow">
          <v-card
            color=" mt-3 "
            style="border-left:1px solid #efefef; border-right:1px solid #efefef;"
            flat
            id="description"
          >
            <v-layout row class="pt-1 pb-1">
              <v-flex xs12>
                <v-card
                  class="card--flex-toolbar"
                  style="box-shadow:none;border-bottom:1px solid #efefef"
                >
                  <v-toolbar card color="white" prominent>
                    <v-toolbar-title
                      class="body-2 grey--text toolbarTitle"
                    >{{gLang[lang].collectionSingle.about}}</v-toolbar-title>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-card-text v-if="collection.description[lang].length > 350">
                    <div v-if="isMinimized">
                      <p class="caption1">
                        <i>{{collection.description[lang].slice(0,351)}}...</i>
                      </p>
                      <v-flex class="text-xs-right">
                        <v-btn
                          flat
                          primary
                          @click="isMinimized = !isMinimized"
                        >{{gLang[lang].collectionSingle.readMore}}</v-btn>
                      </v-flex>
                    </div>
                    <div v-if="!isMinimized">
                      <p class="caption1">
                        <i>{{collection.description[lang]}}</i>
                      </p>
                      <v-flex class="text-xs-right">
                        <v-btn
                          flat
                          primary
                          @click="isMinimized = !isMinimized"
                        >{{gLang[lang].collectionSingle.readLess}}</v-btn>
                      </v-flex>
                    </div>
                  </v-card-text>
                  <v-card-text v-else>
                    <p class="caption1">
                      <i>{{collection.description[lang]}}</i>
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <v-toolbar card color="white" prominent>
              <v-toolbar-title
                class="body-2 grey--text toolbarTitle"
              >{{gLang[lang].collectionSingle.location}}</v-toolbar-title>
            </v-toolbar>

            <web-location-present-multiple
              style="box-shadow:0px;"
              :groupTitle="collection"
              :heightM="mapHeight"
            ></web-location-present-multiple>
          </v-card>

          <v-card
            color="  mb-3"
            flat
            id="bottomSlider"
            style="background-color:#FAFAFA"
            v-if="artefactsInCollection()"
          >
            <v-toolbar card color="white" prominent>
              <v-toolbar-title
                class="body-2 grey--text toolbarTitle"
              >{{gLang[lang].collectionSingle.artefacts}}</v-toolbar-title>
            </v-toolbar>
            <v-divider class="mb-4"></v-divider>
            <web-slider1 :artefacts="artefacts">
              <div
                v-for="artefact in artefacts"
                :key="artefact._id"
                v-if="(artefact.collectionId.indexOf(collection.title.en) > -1 && lessThen5(artefact._id,collection.title.en))"
              >
                <web-artefact-card :artefact="artefact"></web-artefact-card>
              </div>
            </web-slider1>

            <v-card-actions class="pt-1 mt-0" style=" max-height:70vh">
              <v-flex style=" max-height:80%" class="text-xs-right">
                <v-dialog
                  v-model="dialog2"
                  full-width
                  transition="dialog-bottom-transition"
                  max-width="1300"
                  max-height="800"
                  :overlay="false"
                  class="artefactsDialog"
                >
                  <v-btn
                    color="black"
                    dark
                    flat
                    slot="activator"
                  >{{gLang[lang].collectionSingle.show}}</v-btn>
                  <div style="height:70vh; overflow-y:scroll">
                    <v-card style="z-index:20200;">
                      <!-- <v-toolbar dark color="primary" style="margin-top:100px;">
          
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn light flat @click.native="dialog = false">Save</v-btn>
          </v-toolbar-items>
                      </v-toolbar>-->
                      <v-btn
                        icon
                        @click.native="dialog2 = false"
                        class="artefactsDialogButton"
                        light
                        style="margin-top:16px;"
                      >
                        <v-icon>arrow_back</v-icon>
                      </v-btn>

                      <div>
                        <v-container class="modalContainer">
                          <v-layout row wrap>
                            <v-flex
                              md4
                              class="pa-1"
                              v-for="artefact in artefacts"
                              :key="artefact._id"
                              v-if="(artefact.collectionId.indexOf(collection.title.en) > -1)"
                            >
                              <web-artefact-card class="modal-card" :artefact="artefact"></web-artefact-card>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </div>
                    </v-card>
                  </div>
                </v-dialog>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- <v-flex xs4>
        <img class="variableWidth" id="myImg2" v-on:resize="handleSize()"  v-on:click="imageClick('https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg')" style="width:100px; height:100px" src="https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg" alt="">
      </v-flex>
      <v-flex xs4>
        <img class="variableWidth" id="myImg3" v-on:resize="handleSize()"  v-on:click="imageClick('http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23')" style="width:100px; height:100px" src="http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23" alt="">
      </v-flex>
    </v-layout>
    <v-layout row justify-center class="pl-2">
      <v-flex xs4>-->
      <!-- {{image.Url}} will be added as an argument to the imageClick function -->
      <!-- <img class="variableWidth" id="myImg4" v-on:resize="handleSize()"  v-on:click="imageClick('https://i.pinimg.com/736x/71/12/80/71128071f2b38e1a093aab2b6eacb9c5--melted-crayon-diy-crayon-melting-canvas.jpg')"  style="width:100px; height:100px" src="https://i.pinimg.com/736x/71/12/80/71128071f2b38e1a093aab2b6eacb9c5--melted-crayon-diy-crayon-melting-canvas.jpg" alt="">
      </v-flex>
      <v-flex xs4>
        <img class="variableWidth" id="myImg5" v-on:resize="handleSize()"  v-on:click="imageClick('https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg')" style="width:100px; height:100px" src="https://www.bloomberg.com/features/2017-art-auction-estimates-quiz/img/art-quiz-bloomberg-question-02.jpg" alt="">
      </v-flex>
      <v-flex xs4>
        <img class="variableWidth" id="myImg6"  v-on:resize="handleSize()" v-on:click="imageClick('http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23')" style="width:100px; height:100px" src="http://moma.org/d/assets/W1siZiIsIjIwMTUvMTAvMjEvaWJ3dmJmanIyX3N0YXJyeW5pZ2h0LmpwZyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ/starrynight.jpg?sha=161d3d1fb5eb4b23" alt="">
      </v-flex>-->
      <!-- The Modal -->
      <div style="margin-top:56px;" id="myModal" class="modal pt-5">
        <v-btn dark medium fab color="black" v-on:click="spanClick" class="close">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <div
          v-for="artefact in artefacts"
          :key="artefact._id"
          v-if="(artefact.collectionId.indexOf(collection.title.en) > -1)"
        >
          <v-container>
            <v-layout row wrap>
              <web-artefact-card class="modal-card" :artefact="artefact"></web-artefact-card>
            </v-layout>
          </v-container>
        </div>
      </div>

      <!-- <iframe id="video" class="video"
:src="media.data[0].url">
      </iframe>-->
      <v-divider></v-divider>

      <!-- <vue-audio :file="media.data[0].url"></vue-audio> -->
      <!-- <v-layout row>
          <div class=" ml-3 mb-3 mt-2 pa-1 mr-3 icon-circle primary" style="">
        <v-icon dark >library_music</v-icon>
          </div>
          <div>
            <a class="pdfText" href=""> <b>{{media.data[0].originalName}}</b></a> <br>
            <p class="pdfDate">{{artefact.meta.creationDate | date}}</p>
        </div>   
                 
      </v-layout>-->
      <v-speed-dial
        id="bottom_button"
        class="app-vue-speeddial"
        v-if="!isAdmin && isLoggedIn"
        v-model="fab"
        :top="top"
        :bottom="bottom"
        :right="right"
        :left="left"
        :direction="direction"
        :hover="hover"
        :transition="transition"
        fixed
      >
        <v-btn
          class="ma-1"
          slot="activator"
          color="primary"
          dark
          fab
          hover
          v-model="fab"
          to="/artefacts/new"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-container>
  </div>
</template>


<script>
import axios from "axios";
import Slick from "vue-slick";
export default {
  metaInfo() {
    return {
      title: this.sanitizeString(this.collection.title[this.lang]),
      meta: [
        {
          vmid: "og:title",
          name: "og:title",
          content: this.sanitizeString(this.collection.title[this.lang])
        },
        { vmid: "og:type", name: "og:type", content: "article" },
        {
          vmid: "og:article:published_time",
          name: "og:article:published_time",
          content: this.sanitizeString(this.collection.meta.creationDate)
        },
        {
          vmid: "og:article:section",
          name: "og:article:section",
          content: this.sanitizeString(this.collection.title[this.lang])
        },
        { vmid: "og:locale", name: "og:locale", content: "ro_RO" },
        {
          vmid: "og:locale:alternate",
          name: "og:locale:alternate",
          content: "sr_SR"
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.sanitizeString(this.collection.description[this.lang])
        },
        {
          vmid: "og:url",
          name: "og:url",
          content:
            "https://www.hera.uvt.ro/artefacts/" +
            this.sanitizeString(this.collection._id)
        },
        {
          vmid: "og:image",
          name: "og:image",
          content: "https://www.hera.uvt.ro" + this.collection.imgUrl[0].url
        },
        { vmid: "og:site_name", name: "og:site_name", content: "HErA" }
      ],
      script: [
        {
          innerHTML: `{ "@context": "http://schema.org",
          "@type": "Article",
          "dateCreated":"${this.sanitizeString(
            this.collection.meta.creationDate
          )}", 
          "isFamilyFriendly":"true",
          "thumbnailUrl":"${"https://www.hera.uvt.ro" +
            this.collection.imgUrl[0].url}",
          "name": "${this.sanitizeString(this.collection.title[this.lang])}",
          "description": "${this.sanitizeString(
            this.collection.description[this.lang]
          )}",
          "image": "${"https://www.hera.uvt.ro" +
            this.collection.imgUrl[0].url}",
          "url":"${"https://www.hera.uvt.ro/artefacts/" +
            this.sanitizeString(this.collection._id)}"
           
           }`,
          type: "application/ld+json"
        }
      ]
    };
  },

  watch: {
    id() {
      this.isLoading = true;
      this.fetchData();
    }
    // $route (to, from) {
    //   console.log('fwgr');
    //   var self = this
    //   self.isLoading = true

    //   self.fetchData().then(function () {

    //   })
    // }
  },
  data() {
    return {
      mapHeight: 600,
      mapHeight1: 300,
      direction: "left",
      fab: false,
      dialog: false,
      dialog2: false,
      fling: false,
      hover: false,
      col: "",
      tabs: null,
      top: false,
      isLoading: true,
      fetchError: null,
      right: true,
      bottom: true,
      collection: {
        _id: "",
        title: {
          en: "",
          sr: "",
          ro: ""
        },
        meta: {
          author: "",
          creationDate: ""
        },
        description: {
          en: "",
          sr: "",
          ro: ""
        },
        imgUrl: [
          {
            url: ""
          }
        ]
      },
      left: false,
      transition: "slide-y-reverse-transition",
      slickOptions: {
        autoplay: true,
        dots: false,
        infinite: true,
        arrows: false,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      },
      overview: true,
      isMinimized: true
    };
  },
  props: ["id"],
  // route: {
  //           data: function (transition) {
  //               this.getDetails(transition);
  //           }
  //       },

  methods: {
    sanitizeString(str) {
      str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
      return str.trim();
    },
    getLanguageTranslation(col) {
      if (
        this.groups.find(cole => {
          return cole.title.en == col;
        })
      )
        return this.groups.find(cole => {
          return cole.title.en == col;
        }).title[this.lang];
      else return false;
    },
    fetchData: function() {
      var self = this;
      return axios
        .get("/api/collections/" + this.id)
        .then(function(response) {
          if (response.data.name == "CastError") {
            self.$router.push("/404");
            console.log(response.data.name);
          } else {
            self.collection = response.data;
            self.isLoading = false;
            self.$store.dispatch("updateCollectionVisits", {
              collection: response.data,
              userId:
                self.user && self.user != {} && self.user._id
                  ? self.user._id
                  : self.$store.getters.getIdentifier,
              date: Date.now()
            });
          }
        })
        .catch(function(error) {
          self.fetchError = error;
        });
    },
    // getUserDetails(transition)
    //         {
    //             this.$http.get('/collections/' + this.id)
    //                 .then(function (response) {
    //                     this.collection = col;
    //                     transition.next();
    //                 });

    //         },
    artefactsInCollection() {
      // v-for="collection in collections" :key="collection._id" v-if="(collection.groups.indexOf(group.title) > -1)"

      var i = 0,
        j = 0;

      for (i = 0; i < this.artefacts.length; i++) {
        for (j = 0; j < this.artefacts[i].collectionId.length; j++)
          if (this.artefacts[i].collectionId[j] == this.collection.title.en) {
            return true;
          }
      }

      return false;
    },
    addToFav() {
      if (!this.collection.favorite.includes(this.user._id)) {
        this.collection.favorite.push(this.user._id);
        this.$store.dispatch("updateCollection", this.collection);
      } else {
        for (var i = this.collection.favorite.length - 1; i >= 0; i--) {
          if (this.collection.favorite[i] === this.user._id) {
            this.collection.favorite.splice(i, 1);
            break; //<-- Uncomment  if only the first term has to be removed
          }
        }
        this.$store.dispatch("updateCollection", this.collection);
      }
    },
    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }

    //   },

    changeCardHeight(admin) {
      var card = document.getElementById("card-variable-height");

      if (admin) {
        card.style.height = screen.height - 110 + "px";
      } else {
        card.style.height = 92 + "vh";
      }
    },
    lessThen5(idart, coltitle) {
      var j,
        k = [];

      for (j = 0; j < this.artefacts.length; j++)
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1)
          k.push(this.artefacts[j]._id);

      if (
        k[0] == idart ||
        k[1] == idart ||
        k[2] == idart ||
        k[3] == idart ||
        k[4] == idart
      )
        return true;
      else return false;
    },
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    showAll: function() {
      var modal = document.getElementById("myModal");

      modal.style.display = "block";
    },
    minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    },
    deleteArtefact: function() {
      this.$store.dispatch("deleteCollection", this.collection);
      this.$router.push("/");
    },
    // blabla(){
    //       this.$store.dispatch("loadArtefacts");
    //       this.onResize();
    // },
    spanClick: function() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.moveButton(this.isAdmin);
    this.fetchData();
    if (!this.collection) this.$router.push("/404");
    this.changeCardHeight(this.isAdmin);
    document.title = this.collection.title[this.lang];
  },
  created() {
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadUsers");
    this.collection.visited++;
  },
  computed: {
    groups() {
      return this.$store.getters.loadGroups;
    },
    lang() {
      return this.$store.getters.loadLang;
    },
    favorited() {
      if (this.collection.favorite)
        return this.collection.favorite.includes(this.user._id);
      else return false;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    // collection() {
    //   return this.$store.getters.loadCollectionSingle(this.id);
    // },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    user() {
      return this.$store.getters.getUser;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  components: { Slick }
};
</script>

<style>
.shadow {
  -webkit-box-shadow: 0px 0px 12px -1px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: 0px 0px 12px -1px rgba(0, 0, 0, 0.32);
  box-shadow: 0px 0px 12px -1px rgba(0, 0, 0, 0.32);
}

.timeline-item {
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  padding: 25px;
  margin: 0 auto;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.animated-background {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 538px;
  position: relative;
  width: 1000px;
}

.background-masker {
  background: #fff;
  position: absolute;
}

/* Every thing below this is just positioning */

.background-masker.header-top {
  top: 400px;
  left: 0px;
  right: 0;
  height: 30px;
}

.background-masker.header-bottom {
  top: 480px;
  height: 9px;
  left: 0px;
  right: 0;
}

.background-masker.header-left {
  top: 450px;
  left: 0px;
  height: 8px;
  width: 100%;
}

/*  */

.background-masker.header-right {
  top: 509px;
  height: 9px;
  width: 100%;
  left: 0;
}
</style>




<style>
/* .card__media__background:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to bottom right, #000000, #000000);
  opacity: 0.3;
}
.curved {
  border-bottom-right-radius: 40% 10%;
  border-bottom-left-radius: 50% 10%;
} */

#myImg:hover,
#myImg2:hover,
#myImg3:hover,
#myImg4:hover,
#myImg5:hover,
#myImg6:hover {
  opacity: 0.7;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 50; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: fixed !important;
  top: 10% !important;
  left: 2% !important;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
  background-color: transparent;
  z-index: 900;
  opacity: 0.7;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

.icon-circle {
  border-radius: 32px;
}

.pdfText {
  text-decoration: none;
  color: black !important;
  outline: none;
}

.pdfDate {
  font-size: 0.8em;
  color: grey;
}

.uploadedFilesText {
  color: grey;
}

.headerIcons {
  position: absolute;
  top: 6%;
  right: 4%;
}

.description p {
  text-align: justify;
}
html,
body {
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
}
</style>


<style src='@/../node_modules/slick-carousel/slick/slick.css'>
</style>


<style scoped>
@media screen and (max-width: 600px) {
  /* .modalContainer {
    padding: 8px;
  }
  .artefactsDialog {
    margin: 8px;
	} */
  .artefactsDialogButton {
    margin-top: 70px;
  }
}

.toolbarTitle {
  font-size: 20px !important;
  font-weight: 400;
}

.show-ie {
  display: none;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .hide-ie {
    display: none;
  }
  .show-ie {
    display: block;
  }
}
.mainImg-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
}

.mainImg-overlay1 {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: 74vh;
}

.floatingScrollButton {
  position: fixed;
  width: 100%;
  height: 60vh;
}

.caption1 {
  font-size: 1.1em;
  text-indent: 15px;
}

.caption1,
.caption {
  font-weight: 200;
  text-align: justify;
}
.modal-card {
  width: 100%;
}

.wave-img {
  position: absolute;
  bottom: 0%;
  background-image: url("../../assets/wave_border.png");
  background-position: left bottom;
  width: 100%;
  height: 100%;
  background-size: contain;
}
.wave-img1 {
  position: fixed;
  bottom: 13%;
  background-image: url("../../assets/grey-wave-desk.png");
  background-position: left bottom;
  width: 100vw;
  height: 30vh;
  background-size: cover;
}
.headerButtons:hover {
  opacity: 0.4;
}
</style>




// WEBPACK FOOTER //
// src/components/Common/CollectionSingle.vue